import React from 'react';

function ConsultarRUC() {
  return <h1>Consulta de RUC</h1>;
}

export default ConsultarRUC;
